import { MarketDesignContext, TMarketDesignContextState } from 'src/pages/MarketDesignMobile';

import { useContext } from 'react';

const useMarketDesignContext = (): TMarketDesignContextState => useContext(MarketDesignContext);

export default useMarketDesignContext;
